module.exports = __webpack_public_path__ + "img/free01_800x400.049f0d11.jpg";